import React from 'react';
import LoadingScreen from '../LoadingScreen';
import LoginButton from './LoginButton';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Image from 'react-bootstrap/Image';
import { Col } from 'react-bootstrap';

/**
 * Login screen
 */
export default class LoginScreen extends React.Component<{},any>{

    constructor(props: {}) {
        super(props);
        this.state = {
            loading: false
        }
    }

    render() {
        return (
            <>
                <div className="noscroll-page">
                    <img className='full-background' src="/assets/background/img_consensus.jpg"></img>
                    <Container className='h-100'>
                        <Row className="justify-content-center align-items-center text-center h-100">
                            <Col xs="2"></Col>
                            <Col style={{backgroundColor: "#ffffff"}} className="columns-vertical-center pt-5 pb-5 pl-3 pr-3 shadow rounded">
                                <div className='div-horizontal-center logo-login-container'>
                                <Image src="/assets/logo/nokia_logo.svg" width={325} height={125} fluid />
                                <h1 className='title-login-container h1 mt-5 mb-2'>Welcome to <br/><b>Wavence Link Designer</b></h1>
                                </div>
                                <LoginButton onLoad={(res: boolean) => { this.setState({'loading': true}); } }></LoginButton>
                            </Col>
                            <Col xs="2"></Col>
                        </Row>
                    </Container>
                </div>
                <LoadingScreen displayed={this.state.loading} />
            </>
        );
    }

}